import type { LoyaltyEventCode } from "Infrastructure/Api/Api";

export enum SessionStorageKeys {
  BankExpirationModalDismissed = "wasBankExpirationModalDismissed",
  MerchantAccessSent = "merchantAccessSent",
  IsAndroidTwa = "isAndroidTwa",
  GoogleLinkNonce = "googleLinkNonce",
  BankReturnRelayed = "bankReturnRelayed",
}

/**
 * One entry per bank landing already relayed to the backend (useBankReturnRelay): the landing URL stays in the
 * browser history, and a refresh or Back must not report the same bank verdict twice.
 */
export const getBankReturnRelayedKey = (
  transactionPublicID: string,
  search: string,
): `${SessionStorageKeys.BankReturnRelayed}_${string}` =>
  `${SessionStorageKeys.BankReturnRelayed}_${transactionPublicID}_${search}`;

// (string & {}) keeps enum autocomplete while still allowing dynamic keys.
export type SessionStorageKey =
  | SessionStorageKeys
  | LoyaltyEventCode
  | (string & {});
